var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.5,14.5C35.953,14.5,29,21.453,29,30c0,7.444-6.056,13.5-13.5,13.5S2,37.444,2,30s6.056-13.5,13.5-13.5  c2.687,0,5.282,0.787,7.505,2.277c0.74,0.495,1.432,1.065,2.058,1.694c0.39,0.39,1.023,0.393,1.414,0.003  c0.392-0.39,0.393-1.023,0.003-1.415c-0.718-0.721-1.513-1.375-2.361-1.944C21.565,15.404,18.584,14.5,15.5,14.5  C6.953,14.5,0,21.453,0,30s6.953,15.5,15.5,15.5S31,38.547,31,30c0-7.444,6.056-13.5,13.5-13.5S58,22.556,58,30  s-6.056,13.5-13.5,13.5c-3.605,0-6.995-1.403-9.544-3.952c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414  C36.469,43.889,40.36,45.5,44.5,45.5C53.047,45.5,60,38.547,60,30S53.047,14.5,44.5,14.5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#3a444d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheory);
export default __webpack_public_path__ + "static/media/theory.e5454d45f5a8ac978c393d43420211ea.svg";
export { ForwardRef as ReactComponent };